import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { logging } from 'protractor';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
    selector: 'app-withdrawal-reverse',
    templateUrl: './withdrawal-reverse.component.html',
    styleUrls: ['./withdrawal-reverse.component.scss'],
})
export class WithdrawalReverseComponent extends WithdrawalBaseComponent implements OnInit {
    @ViewChild(IonContent) content: IonContent;

    public error = null;
    public confirm: boolean = false;
    public pendingWithdrawals: any = [];
    public payoutLock: boolean;
    public getComplete;
    public labels: DepositMainLabels;
    public PIPE_DATE_FORMAT = !!this.configService.getConfig().FEATURE_TIME_FORMAT ? this.configService.getConfig().FEATURE_TIME_FORMAT : 'MM-dd-yyyy hh:mm a'; //MM-dd-yyyy, hh:mm a' Use this for Full date

    constructor(
        public addressService: AddressService,
        public cashierService: CashierService,
        public cashierContentService: CashierContentService,
        public navigator: Navigator,
        public withdrawService: WithdrawalService,
        public balanceService: AccountBalanceService,
        public utils: UtilsService,
        public events: EventsService,
        public configService: ConfigService,
        public successMessageService: SuccessMessageService,
    ) {
        super();
        // let appConfigInfo = this.configService.getAppConfigInfo();
        // this.payoutLock = appConfigInfo.payoutLock;
        this.successMessageService.clearMessage();
        this.error = null;
        this.labels = new DepositMainModel();
    }

    ngOnInit() { }

    ionViewDidEnter() {
        this.successMessageService.clearMessage();
        this.onGetPendingWithdrawals();
    }

    onGetPendingWithdrawals() {
        this.pendingWithdrawals = [];
        this.withdrawService.callGetPendingWithdrawals().subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    var tempWithdrawals: any = response.payload;
                    for (let index in tempWithdrawals) {
                        this.pendingWithdrawals.push(tempWithdrawals[index]);
                    }
                }
                this.getComplete = true;
            },
            (error) => {
                this.error = error;
                this.getComplete = true;
            }
        );
    }

    ngAfterViewInit() {
        this.cashierContentService.getPageConfig('reverse').then((response: DepositMainLabels) => {
            this.labels = response;
        });
    }

    onReverseClick(withdrawal) {
        this.successMessageService.clearMessage();
        this.error = null;
        this.navigator.navigateTo("WithdrawalReverseConfirmComponent", { multipleModals: false },
            { payoutRequestID: withdrawal.payoutRequestID, amount: withdrawal.amount, navigateBackPage : 'WithdrawalReverseComponent' });
    }

    onReverseWithdraw(payoutRequestID: string) {
        var requestObj: any = {};
        requestObj.payoutRequestID = payoutRequestID;

        // this.logger.log('onReverseWithdraw WithdrawalMailPage', requestObj.payoutRequestID);

        this.withdrawService.callReverseWithdrawal(requestObj).subscribe(
            (response: any) => {
                // this.logger.log("callReverseWithdrawal response = ", response);
                if (response && !!response.result) {
                    this.onGetPendingWithdrawals();

                    this.successMessageService.setMessage('Your withdrawal was successfully reversed.');

                    this.content.scrollToTop();
                }
            },
            (error) => {
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callReverseWithdrawal error = ", error);
            }
        )

        this.error = null;
    }

    pendingWithdrawalsEmiter(data) {
        if (data.success) {
            this.onGetPendingWithdrawals();
        }
        if (data.error) {
            this.error = data.error;
        }
    }

}
